<script setup lang="ts">

import type {TreeNode} from '../types/file_tree';
import DiffFile from './FileTreeItems/FileLike.vue';

import Dir from './FileTreeItems/FileTreeDir.vue';

import ProjectFile from './FileTreeItems/ProjectFile.vue';

const {item, topLevel = false, forceExpand = false} = defineProps<{
  item: TreeNode,
  topLevel?: boolean,
  forceExpand?: boolean,
}>();

// If the file like tree item is at the top level, we avoid adding padding to the left
const topLevelClass = topLevel ? '' : 'tw:pl-4';
</script>

<template>
  <Dir
    v-if="item.ty === 'dir'"
    :item="item"
    :force-expand="forceExpand"
    icon="octicon-file-directory-fill"
  />

  <ProjectFile
    v-else-if="item.ty === 'multi-page-diff'"
    :item="item"
    :class="topLevelClass"
    :force-expand="forceExpand"
    icon="allspice-file-schematic"
  />
  <ProjectFile
    v-else-if="item.ty === 'proj-diff'"
    :item="item"
    :class="topLevelClass"
    :force-expand="forceExpand"
    icon="allspice-file-proj"
  />

  <!-- Render Files or things that look like files for the purpose of the file tree-->
  <DiffFile
    v-else-if="item.ty === 'file-diff'"
    v-bind="item"
    :class="topLevelClass"
    icon="octicon-file"
  />
  <DiffFile
    v-else-if="item.ty === 'sch-diff'"
    v-bind="item"
    :class="topLevelClass"
    icon="allspice-file-schematic"
  />
  <DiffFile
    v-else-if="item.ty === 'proj-page-diff'"
    v-bind="item"
    :class="topLevelClass"
    icon="allspice-file-schematic"
  />
  <DiffFile
    v-else-if="item.ty === 'pcb-diff'"
    v-bind="item"
    :class="topLevelClass"
    icon="allspice-file-pcb"
  />
  <DiffFile
    v-else-if="item.ty === 'pcblib-diff'"
    v-bind="item"
    :class="topLevelClass"
    icon="allspice-file-pcblib"
  />
  <DiffFile
    v-else-if="item.ty === 'schlib-diff'"
    v-bind="item"
    :class="topLevelClass"
    icon="allspice-file-schlib"
  />
  <DiffFile
    v-else-if="item.ty === 'pdf-diff'"
    v-bind="item"
    :class="topLevelClass"
    icon="allspice-file-pdf"
  />
  <DiffFile
    v-else-if="item.ty === 'submodule-diff'"
    v-bind="item"
    :class="topLevelClass"
    icon="octicon-file-submodule"
  />
  <DiffFile
    v-else-if="item.ty === 'symlink-diff'"
    v-bind="item"
    :class="topLevelClass"
    icon="octicon-file-symlink-file"
  />
</template>
